import React, { useEffect, useRef } from 'react'

const AudioPlayer = (props) => {
    const playerId = `player-${new Date().getUTCMilliseconds()}`
    const sourceId = `source-${new Date().getUTCMilliseconds()}`
    const audioRef = useRef(null)

    useEffect(() => {
        const audio = document.getElementById(playerId)
        if (!audio) return

        const handleError = (e) => {
            console.error('Audio playback error:', e)
            // You can add additional error handling here, like showing a user-friendly message
        }

        const handleLoadError = (e) => {
            console.error('Audio loading error:', e)
            // You can add additional error handling here
        }

        audio.addEventListener('error', handleError)
        audio.addEventListener('loaderror', handleLoadError)

        // Only attempt to play if the audio is loaded and ready
        if (audio.readyState >= 2) {
            audio.play().catch(err => {
                console.error('Error playing audio:', err)
            })
        }

        return () => {
            audio.removeEventListener('error', handleError)
            audio.removeEventListener('loaderror', handleLoadError)
        }
    }, [playerId]) // Only run when playerId changes

    return (
        <>
            <div className="d-inline-flex flex-row align-items-center justify-content-center mr-2">
                {!!props.source ? (
                    <audio 
                        id={playerId} 
                        controls
                        ref={audioRef}
                    >
                        <source 
                            id={sourceId} 
                            src={props.source} 
                            type={`audio/${props.audioType || 'mp3'}`} 
                        />
                        Your browser does not support the audio element.
                    </audio>
                ) : null}
            </div>
        </>
    )
}

const PlayPauseBtn = (props) => {
    return (
        <>
            <div onClick={props.handleClick} className="play-pause-btn">
                <i className={`tim-icons ${!props.playing ? 'icon-triangle-right-17' : 'icon-button-pause'} text-success`}></i>
            </div>
        </>
    )
}

export { PlayPauseBtn }

export default AudioPlayer